import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (signature on-load / on-scroll moment)
export const MaskLines = ({ lines, className, lineClass = "", delay = 0, whileInView = false }) => {
  const anim = whileInView
    ? { whileInView: { y: 0 }, viewport: { once: true, margin: "-60px" } }
    : { animate: { y: 0 } };
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.16em]">
          <motion.span
            aria-hidden="true"
            className={"block " + lineClass}
            initial={{ y: "115%" }}
            {...anim}
            transition={{ duration: 0.95, delay: delay + i * 0.11, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
